import { ChangeDetectorRef, Component, EventEmitter, HostBinding, Input, Output, QueryList, signal, SimpleChanges, ViewChild, ViewChildren, WritableSignal } from '@angular/core';

import { UtilService } from 'src/app/services/util.service';
import { ConfirmationService, FilterMetadata, FilterService, MenuItem, SortEvent } from 'primeng/api';

import { Table } from 'primeng/table';
import { ContextMenu } from 'primeng/contextmenu';
import { RolRepository } from 'src/app/roles/domain/rol.repository';
import { StorageService } from 'src/app/services/storage.service';
// import { Router } from '@angular/router';
import { listarOpcionesTablaRequest, transaccionOpcionesTablaRequest } from 'src/app/roles/domain/request/rol_request';

import { Router } from '@angular/router';
import { OverlayPanel } from 'primeng/overlaypanel';
import { readonlyMetadataTable, style } from '../domain/readonly-data-table.domain';
import { newmetadate } from '../../datatable/domain/datatable-domain';
import { PrimeNG } from 'primeng/config';
// import { Router } from '@angular/router';

@Component({
  selector: 'app-readonly-data-table-single',
  templateUrl: './readonly-data-table-single.component.html',
  styleUrls: ['./readonly-data-table-single.component.css'],
  standalone: false
})

export class ReadonlyDataTableSigleComponent {
  bResult: any;
  isHovered = false;//Es para la simulaciond de hover de un checkbox

  constructor(
    public readonly util: UtilService,
    private readonly rol: RolRepository,
    private readonly storage: StorageService,
    private readonly router: Router,
    private primeng: PrimeNG,
    private cdr: ChangeDetectorRef,
    private filterService: FilterService
  ) {
    this.primeng.setTranslation({
      startsWith: 'Comienza con',
      contains: 'Contiene',
      notContains: 'No contiene',
      endsWith: 'Termina con',
      equals: 'Igual a',
      notEquals: 'Diferente a',
      noFilter: 'Sin filtro',
      lt: 'Menor que',
      lte: 'Menor o igual a',
      gt: 'Mayor que',
      gte: 'Mayor o igual a',
      is: 'Es',
      isNot: 'No es',
      before: 'Antes de',
      after: 'Después de',
      dateIs: 'Fecha es',
      dateIsNot: 'Fecha no es',
      dateBefore: 'Fecha es antes de',
      dateAfter: 'Fecha es después de',
      clear: 'Limpiar',
      apply: 'Aplicar',
      matchAll: 'Coincidir con todos',
      matchAny: 'Coincidir con cualquiera',
      addRule: 'Agregar regla',
      removeRule: 'Eliminar regla',
      accept: 'Aceptar',
      reject: 'Cancelar',
      choose: 'Elegir',
      upload: 'Subir',
      cancel: 'Cancelar',
      dayNames: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
      dayNamesShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
      dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
      monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
      monthNamesShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
      today: 'Hoy',
      weekHeader: 'Sem'
    });
  }

  @ViewChild('dt1') table: Table
  @ViewChild('dt2') table2: Table

  @Input() caption: boolean = false;
  @Input() caption2: boolean = false;
  @Input() nombreListaHijos: string;
  @Input() dataTable: any[];
  @Input() title: string = ''
  @Input() filterGlobal: boolean = false;
  @Input() filterGlobalHijos: boolean = false;
  @Input() metadataTable: readonlyMetadataTable[] = [];
  @Input() key: string = ''
  @Input() scrollHeight: string = '400px'
  @Input() rows: any[] = [20, 30, 50]
  @Input() filter: boolean = true;
  @Input() customButtons: { icon?: string; function?: () => void; toolTip?: string; loading?: boolean; disabled?: boolean; type?: string, items?: MenuItem[] }[] = [];
  @Input() style: style;
  @Input() typeFilter: 'row' | 'menu' = 'menu';
  @Input() id: string
  @Input() customLeyendas: { src?: string; function?: () => void; texto?: string }[] = [];
  @Output() Row = new EventEmitter<any>()
  @Input() virtualScroll: boolean = false
  @Input() resaltarCabecera: boolean = false;
  @HostBinding('class.cabecera-resaltada') get aplicarClaseCabecera() { return this.resaltarCabecera; }

  @Input() positionPaginator: 'paginatorcenter' | 'paginatorleft' | 'paginatorright' = 'paginatorcenter'
  @Input() customLeyendasHex: { color?: string; texto?: string }[] = [];

  // @Input() styleRowDynamic: (row) => any;
  // @Output() styleRowDynamic = new EventEmitter<any>();
  @Input() styleRowDynamic: (row: any) => any;
  @Input() showFilters: boolean = false;
  cadenaFiltrosConsolidada: WritableSignal<string> = signal('');

  data: any[] = []
  datatreeview: any[] = []
  metadatatable: readonlyMetadataTable[] = []
  paginator: boolean = true
  metadatechildren: any[] = []
  metadatepather: any[] = []
  valorResize = false
  frozen = false
  Valor: string
  styleHeader: { [key: string]: string } = {}
  styleBody: { [key: string]: string } = {}
  filtrosGlobal: any[] = []
  filtrosGlobalHijos: any[] = []
  sortFieldPadres: string;
  sortOrderPadres: number;
  sortFieldHijos: string = '';
  sortOrderHijos: number;


  getMatchMode(item: any): string {
    return item.type === 'date' ? 'equals' : 'in';
  }

  normalizarFecha(date: Date): Date {
    if (!date) return date;
    date.setHours(0, 0, 0, 0);

    return date;

  }

  filterNew(value: any, item: any) {
    let valorNormalizado = value;

    if (item.type === 'date') {
      if (typeof value === 'string') {
        const fecha = new Date(value);
        valorNormalizado = new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate());
      } else if (value instanceof Date) {
        valorNormalizado = new Date(value.getFullYear(), value.getMonth(), value.getDate());
      } else if (Array.isArray(value)) {
        valorNormalizado = value.map(v => {
          const fecha = new Date(v);
          return new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate());
        });
      }
    }

    item.filterCallback(valorNormalizado);
  }


  ngOnInit() {
    this.customButtons = this.customButtons.map(btn => ({
      type: 'button', // valor por defecto
      ...btn          // sobrescribe si ya trae type
    }));


    //para las fecha filtros vacion
      this.filterService.register('dateIsNull', (value, filter): boolean => {
    return value == null;
  });

  this.filterService.register('dateIsNotNull', (value, filter): boolean => {
    return value != null;
  });

    // this.sortFieldHijos='clientes'
    //==============================================NO BORRAR===========================================================
    // // Recuperar los datos desde sessionStorage
    // const ordenamientoColumnasPadres = sessionStorage.getItem('ordenamientoColumnasPadres');
    // const ordenamientoColumnasHijos = sessionStorage.getItem('ordenamientoColumnasHijos');

    // // Si los datos existen, parsearlos de vuelta a un objeto
    // if (ordenamientoColumnasPadres) {
    //   const sortFieldsPadres = JSON.parse(ordenamientoColumnasPadres);
    //   this.sortFieldPadres=sortFieldsPadres[0].field
    //   this.sortOrderPadres=sortFieldsPadres[0].order
    // }

    // if (ordenamientoColumnasHijos) {
    //   const sortFieldsHijos = JSON.parse(ordenamientoColumnasHijos);
    //   this.sortFieldHijos=sortFieldsHijos[0].field
    //   this.sortOrderHijos=sortFieldsHijos[0].order
    // }
    //============================================== FIN NO BORRAR===========================================================

    this.Valor = "7";
    if (this.style) {
      if (this.style.header) {
        const r = this.style.header
        this.styleHeader = {};
        if (r.align) { this.styleHeader['text-align'] = r.align }
        if (r.size) { this.styleHeader['font-size'] = r.size }
        if (r.justify) { this.styleHeader['justify-content'] = r.justify }
      }
      if (this.style.body) {
        const r = this.style.body
        this.styleBody = {};
        if (r.align) { this.styleBody['text-align'] = r.align }
        if (r.size) { this.styleBody['font-size'] = r.size }
        if (r.justify) { this.styleBody['justify-content'] = r.justify }
      }
    }
    this.caption = this.filterGlobal === true || this.title != '' ? true : false
    this.caption2 = this.filterGlobalHijos === true || this.title != '' ? true : false

    this.metadatatable.forEach(column => {
      const uniqueValues = Array.from(new Set(this.data.map(row => row[column.field])));
      column.list = uniqueValues.map(val => ({ nombre: val, codigo: column.type == 'date' ? new Date(val) : val }));


    });


  }

dateMatchModes = [
  { label: 'Es igual a', value: 'equals' },
  { label: 'Antes de', value: 'before' },
  { label: 'Después de', value: 'after' },
  { label: 'Está vacío', value: 'dateIsNull' },
  { label: 'No está vacío', value: 'dateIsNotNull' }
];

  ngOnChanges(changes: SimpleChanges): void {
    this.mainmetadata = []
    this.metadataTable.forEach(r => {
      this.mainmetadata.push(r)
    })
    this.metadatatable = this.metadataTable

    this.metadatechildren = this.metadatatable.filter(r => r.type == 'array')
    this.data = this.dataTable

    this.metadatatable.forEach(column => {
      const uniqueValues = Array.from(new Set(this.data.map(row => row[column.field])));
      column.list = //uniqueValues.map(val => ({ nombre: column.type == 'date' ? new Date(val) : val, codigo: column.type == 'date' ? new Date(val) : val }));
        [
          { nombre: 'VACIOS', codigo: null },   // 👈 opción vacía
          ...uniqueValues.map(val => ({
            nombre: val,
            codigo: column.type == 'date' ? new Date(val) : val
          }))
        ];
    });


    if (this.data.length > this.rows[0] && this.paginator == true) { this.paginator = true }


    if (changes['metadataTable'] && this.metadataTable && this.metadataTable.length > 0) {

      this.metadataTable.forEach(r => {
        this.filtrosGlobal.push(r.field);
        const item = { field: r.field, header: r.title }
        this.cols.push(item)
      });
      this._selectedColumns = this.cols;


    }

    if (this.id) {
      const request = <listarOpcionesTablaRequest>{}
      request.usuario = this.storage.get('usuario')
      request.opcion = this.router.url
      request.tabla = this.id.toString().replace(/'/g, "")
      request.tab = ''
      this.rol.listarOpcionesTabla(request).subscribe(response => {

        if (response.datos.status === 200) {
          this._selectedColumns = []
          const valores = this.metadataTable.filter(r => response.datos.result.some(e => e.field === r.field))
          valores.forEach(x => {
            const item = { field: x.field, header: x.title }
            this._selectedColumns.push(item)
          })

          setTimeout(() => {
            this.metadatatable = this.metadataTable.filter(r =>
              response.datos.result.some(e => e.field === r.field)
            );
            this.mainmetadata = this.mainmetadata.filter(r =>
              !this.metadatatable.some(e => e.field === r.field)
            );
          }, 0);

        }
      })
    }

  }

  ngAfterContentInit(): void {
    const request = <listarOpcionesTablaRequest>{}
    request.usuario = this.storage.get('usuario')
    request.opcion = this.router.url
    request.tabla = this.id?.toString()?.replace(/'/g, "")
    request.tab = ''
    this.rol.listarOpcionesTabla(request).subscribe(response => {

      if (response.datos.status === 200) {
        this._selectedColumns = []
        const valores = this.metadataTable.filter(r => response.datos.result.some(e => e.field === r.field))
        valores.forEach(x => {
          const item = { field: x.field, header: x.title }
          this._selectedColumns.push(item)
        })

        setTimeout(() => {
          this.metadatatable = this.metadataTable.filter(r =>
            response.datos.result.some(e => e.field === r.field)
          );
        }, 0);

      }
    })
  }

  DespliegueHijos(row) {
    this.metadataTable[this.metadataTable.length - 1].metadata.forEach(r => {
      this.filtrosGlobalHijos.push(r.field);
    });
  }


  selectedDate: any = null;
  handleDateSelect(event: any, rowdata: any) {
    this.selectedDate = rowdata[this.key];
  }
  selectDropdown: string
  handleDropdownSelect(event: any) {
    // console.log(event)
    this.selectDropdown = event
  }

  visible: boolean;
  toggleState: boolean = true;
  visibleP_Dialog_General: boolean;
  visibleDialog: boolean;
  visibleTextArea: boolean;
  visibleTextAreaEdit: boolean;
  datoTextArea: string
  tituloP1_Dialog: string
  textAreaEditBtn: boolean = false;
  funcionx: any;
  selectedRow: any; // Variable para guardar el row seleccionado
  elementoOrigen: any;
  showDialog(row: any, title: string, field: string, modal: string, funcion: Function, dato: string) {
    this.visibleP_Dialog_General = true
    this.visibleDialog = true
    this.visibleTextAreaEdit = true;
    this.visibleTextArea = true;
    this.textAreaEditBtn = true;
    this.tituloP1_Dialog = title
    if (modal == "textArea") {
      this.visibleDialog = false
      this.visibleTextArea = true
      this.visibleTextAreaEdit = false
      this.textAreaEditBtn = false
      this.datoTextArea = dato
      this.funcionx = funcion; // Guardar la función
      this.selectedRow = row; // Guardar el row seleccionado
    } else if (modal == "textAreaEdit") {
      this.visibleDialog = false
      this.visibleTextArea = false
      this.visibleTextAreaEdit = true
      this.textAreaEditBtn = false
      this.datoTextArea = row[field];

      // this.datoTextArea = row.doov_mbl;
      this.funcionx = funcion; // Guardar la función
      this.selectedRow = row; // Guardar el row seleccionado
      // this.mensajeDialog = { datoTextArea: row.doov_mbl}
    } else if (modal == "textAreaEditBtn") {
      this.visibleDialog = false
      this.visibleTextArea = false
      this.visibleTextAreaEdit = false
      this.textAreaEditBtn = true
      this.datoTextArea = row[field];

      // this.datoTextArea = row.doov_mbl;
      if (row && row.event) {
        this.elementoOrigen = row.event.currentTarget || row.event.target;
      }
      this.funcionx = funcion; // Guardar la función
      this.selectedRow = row; // Guardar el row seleccionado
      // this.mensajeDialog = { datoTextArea: row.doov_mbl}
    }

  }


  onConfirm(event) {
    if (this.funcionx && this.selectedRow) {
      this.funcionx({
        event: { target: this.elementoOrigen, currentTarget: this.elementoOrigen },
        row: this.selectedRow, dato: this.datoTextArea
      });
      this.visibleP_Dialog_General = false
      this.visibleDialog = false
      this.visibleTextArea = false
      this.visibleTextAreaEdit = false
      this.textAreaEditBtn = false
    }
  }

  onConfirmV2(event) {
    if (this.funcionx && this.selectedRow) {
      this.util.MessageDialog({
        titulo: 'Confirmación',
        mensaje: "¿Está seguro que desea aplicar el cambio asignado?",
        icono: "pi pi-exclamation-triangle",
        tipo: "warning",
        textoBtn: {
          textoBtnOpcion1: "Aceptar",
          textoBtnOpcion2: "Cancelar"
        },
        pregunta: {
          onAccept: () => {
            this.funcionx({
              event: { target: this.elementoOrigen, currentTarget: this.elementoOrigen },
              row: this.selectedRow,
              dato: this.datoTextArea
            });
            this.visibleP_Dialog_General = false
            this.visibleDialog = false
            this.visibleTextArea = false
            this.visibleTextAreaEdit = false
            this.textAreaEditBtn = false
          },
          onReject: () => {
            return;
          }
        }
      });
    }
  }

  verdato(dato: any) {
    // console.log(dato)
  }

  isDisabled() {
    this.selectedDate = null;
  }
  isDisabledDropdwon() {
    this.selectDropdown = null;
  }

  parseDateFromString(dateStr: string): any {

    let dateV: any

    if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateStr) == true) {
      const [day, month, year] = dateStr.split('-')
      dateV = new Date(+year, +month - 1, +day);
    } else {
      dateV = dateStr;
    }

    return dateV
  }

  generateStyle(data: any): { [key: string]: string } {
    let value = {}
    if (data) {
      if (data.align) { value['text-align'] = data.align }
      if (data.size) { value['font-size'] = data.size }
      if (data.justify) { value['justify-content'] = data.justify }
      if (data.width) { value['max-width'] = data.width }
    }
    return value
  }

  isPopupVisible: boolean = false;

  // Método para mostrar el popup
  showPopup() {
    this.isPopupVisible = true;
  }

  // Método para ocultar el popup
  hidePopup() {
    this.isPopupVisible = false;
  }

  bool(value: any): boolean {
    if (value === 'true') {
      return true;
    }
    if (value === 'false') {
      return false;
    }
    return !!value; // Convierte a booleano para otros casos (como null, undefined, 0, etc.)
  }

  getButtonStyle(isActive: boolean): any {
    if (isActive) {
      return {}; // Estilo por defecto cuando es true
    } else {
      return {
        'background-color': 'white',
        'border': '2px solid #ced4da',
        'transition': 'background-color .2s,color .2s,border-color .2s,box-shadow .2s'
      };
    }
  }
  clear(table: Table) {
    table.clear();
    this.filterTableData.emit([]);
  }
  clear2(table2: Table) {
    table2.clear();
  }

  selectedProduct: any;
  @Input() contextMenu: MenuItem[]
  @ViewChild('expmenu') expmenu: ContextMenu
  @Output() selectedRowData = new EventEmitter<any>()
  rowElement: HTMLElement;
  onRowRightClick(event: MouseEvent, rowdata: any) {
    event.preventDefault();
    this.rowElement = event.currentTarget as HTMLElement;
    this.selectedRowData.emit(rowdata);
  }

  @ViewChild('dt1') dt1: Table | undefined;

  onGlobalFilter(value: string): void {
    if (this.dt1) {
      this.dt1.filterGlobal(value, 'contains');
    }
  }

  @Output() filterTableData = new EventEmitter<any[]>();

  filteredData: any[] = [];

  manualFilter(value: string): void {
    if (this.dt1 && this.dt1._value) {
      const searchValue = value.toString().toLowerCase();
      this.filteredData = this.dt1._value.filter(item => {
        return this.containsInParentProperties(item, searchValue);
      })
      this.filterTableData.emit(this.filteredData);
    }
  }

  containsInParentProperties(item: any, searchValue: string): boolean {
    for (let key in item) {
      if (item.hasOwnProperty(key)) {
        const propertyValue = item[key];
        if (propertyValue && propertyValue.toString) {
          if (propertyValue.toString().toLowerCase().includes(searchValue)) {
            return true;
          }
        }
      }
    }
    return false;
  }

  checkList: any[] = []
  onChangeCheckList(event: Event, row: any): void {

    if (row.index === undefined || row.index === null || row.index === '') {
      return
    }

    if (event['checked']) {
      this.checkList.push(row)
    } else {
      this.checkList = this.checkList.filter(item => item.index !== row.index)
    }
  }

  resetCheckList(): void {
    this.checkList = []
  }
  dropdownList: any[] = []
  rowdropdown: any[] = []
  listacombinada: any[] = []
  onChangeDropdownList(event, row) {
    event.value
    this.dropdownList.push(event.value)
    this.rowdropdown.push(row)

    this.listacombinada = this.dropdownList.map((value, index) => ({
      dropdownValue: value,
      rowValue: this.rowdropdown[index]
    }))

  }

  onButtonClick(event: MouseEvent, item2: any): void {
    event.stopPropagation();  // Detiene la propagación del clic

    // Llama a la función de tu lógica aquí
    item2.function(this.listacombinada);
  }

  isSorted: boolean = null;
  @ViewChild('dt2') dt2: Table;
  customSort(event: SortEvent) {


    event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = null;

      if (value1 == null && value2 != null) result = -1;
      else if (value1 != null && value2 == null) result = 1;
      else if (value1 == null && value2 == null) result = 0;
      else if (typeof value1 === 'string' && typeof value2 === 'string') result = value1.localeCompare(value2);
      else result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;

      return event.order * result;
    });

    this.sortFieldHijos = event.field
    this.sortOrderHijos = event.order


  }



  verDetalle() {
    this.sortFieldHijos = 'cliente'
  }

  onChangeButtonArchivos(rowdata) {
    if (!rowdata.ovar_archivo) {
      return;
    }
    const extension = rowdata.ovar_descrip.split('.').pop();
    const mimeType = this.getMimeType(extension);
    const fileName = `archivo_${rowdata.ovar_codigo}.${extension}`;

    const byteCharacters = atob(rowdata.ovar_archivo);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);

  }

  getMimeType(extension: string): string {
    const mimeTypes: { [key: string]: string } = {
      'png': 'image/png',
      'jpg': 'image/jpeg',
      'jpeg': 'image/jpeg',
      'gif': 'image/gif',
      'pdf': 'application/pdf',
      'txt': 'text/plain',
      'doc': 'application/msword',
      'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'xls': 'application/vnd.ms-excel',
      'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'zip': 'application/zip',
    };

    return mimeTypes[extension.toLowerCase()] || 'application/octet-stream';
  }

  botonDescargar: boolean = false;
  desbloquearBotonDescargar(event: MouseEvent, item2: any, row: any): void {
    event.stopPropagation();
    if (item2.header === 'miCabecera' || (row.ovar_archivo && row.ovar_archivo.trim() !== '')) {
      this.botonDescargar = true;
    } else {
      this.botonDescargar = false;
    }
  }

  esBotonHabilitado(item2: any, row: any): boolean {
    return item2.header === 'miCabecera' || (row.ovar_archivo && row.ovar_archivo.trim() !== '');
  }

  loadingBtnSave: boolean = false;
  saveOptionColumn() {
    const request = <transaccionOpcionesTablaRequest>{}

    request.usuario = this.storage.get('usuario')
    request.opcion = this.router.url
    request.tabla = this.id.toString().replace(/'/g, "")
    request.tab = ''

    let opcionesmetadata = []

    this.metadatatable.forEach(r => {
      opcionesmetadata.push({ tabl_field: r.field })
    })

    request.opciones = opcionesmetadata
    request.tipo = 'I'
    this.loadingBtnSave = true;

    this.rol.transaccionOpcionesTabla(request).subscribe(response => {
      if (response.datos.status === 200) {
        this.util.MessageDialog({ mensaje: 'Configuración asignada.', tipo: 'ok' })
        this.loadingBtnSave = false;
        this.optionColumns = false;
        this.cdr.detectChanges();
      }
    }), err => {
      this.loadingBtnSave = false;
      const mensaje = err?.error?.meta?.mensaje || (err?.error?.errors ? Object.values(err.error.errors).flat().join(' | ') : 'Error');
      this.util.MessageDialog({ mensaje: mensaje, tipo: 'warning', icono: 'pi pi-exclamation-triangle' });
      this.optionColumns = false;
      this.cdr.detectChanges();
    }
  }

  cols: any[] = []
  _selectedColumns: any[] = []
  @Input() get selectedColumns(): any[] {
    return this._selectedColumns
  }

  set selectedColumns(val: any[]) {

    this._selectedColumns = this.cols.filter((col) =>
      val.some((v) => v.field === col.field)
    )

    this.metadatatable = this.metadataTable.filter(r =>
      this._selectedColumns.some(e => e.field === r.field)
    )
  }


  optionColumns: boolean
  showOptionColumns() {
    this.optionColumns = true
  }

  mainmetadata: newmetadate[] = []


  saveOptionColumns() {
    const request = <transaccionOpcionesTablaRequest>{}

    request.usuario = this.storage.get('usuario')
    request.opcion = this.router.url
    request.tabla = this.id.toString().replace(/'/g, "")
    request.tab = ''

    let opcionesmetadata = []

    this.metadatatable.forEach((r, i) => {
      opcionesmetadata.push({ tabl_field: r.field, tabl_index: i })
    })

    request.opciones = opcionesmetadata
    request.tipo = 'I'
    this.loadingBtnSave = true;
    this.rol.transaccionOpcionesTabla(request).subscribe(response => {
      if (response.datos.status === 200) {
        this.loadingBtnSave = false;
        this.util.MessageDialog({ mensaje: 'Configuración asignada.', tipo: 'ok' })
        this.optionColumns = false;
      }
    }), err => {
      this.loadingBtnSave = false;
      const mensaje = err?.error?.meta?.mensaje || (err?.error?.errors ? Object.values(err.error.errors).flat().join(' | ') : 'Error');
      this.util.MessageDialog({ mensaje: mensaje, tipo: 'warning', icono: 'pi pi-exclamation-triangle' });
      this.optionColumns = false;
    }

  }
  onRowSelect(event) { this.Row.emit(event.data) }


  filters: { [key: string]: any[] } = {};
  currentFilterField: string = '';

  @ViewChildren(OverlayPanel) opPanels!: QueryList<OverlayPanel>;

  showFilter(event: Event, field: string) {
    this.currentFilterField = field;

    // Oculta cualquier otro overlayPanel que esté abierto
    this.opPanels.forEach(op => op.hide());

    // Muestra solo el overlayPanel correspondiente al botón
    const op = this.opPanels.find(() => true); // Solo hay uno en este ejemplo
    op?.toggle(event);
  }

  getUniqueValues(field: string): { label: string, value: string }[] {
    const values = Array.from(new Set(this.data.map(item => item[field])));
    return values.map(val => ({ label: val, value: val }));
  }

  applyFilters() {
    this.filteredData = this.data.filter(row =>
      this.cols.every(col => {
        const selected = this.filters[col.field];
        return selected.length === 0 || selected.includes(row[col.field]);
      })
    );
  }

  getOperadorExpresion(matchMode: string, fieldName: string): string {
    const mode = matchMode.toLowerCase();

    const isDate = fieldName.includes('fecha') || fieldName.includes('date');
    const isNumber = fieldName.includes('costo') || fieldName.includes('profit') || fieldName.includes('venta') || fieldName.includes('dias');

    if (isDate) {
      switch (mode) {
        case 'dateis': return '=';
        case 'dateisnot': return '!=';
        case 'datebefore': return '<';
        case 'dateafter': return '>';
      }
    }

    if (isNumber) {
      switch (mode) {
        case 'equals': return '=';
        case 'notequals': return '!=';
        case 'lt': return '<';
        case 'lte': return '<=';
        case 'gt': return '>';
        case 'gte': return '>=';
      }
    }

    switch (mode) {
      case 'startswith': return 'EMPIEZA CON';
      case 'contains': return 'CONTIENE';
      case 'notcontains': return 'NO CONTIENE';
      case 'endswith': return 'TERMINA CON';
      case 'equals': return '=';
      case 'notequals': return '!=';
      default: return mode.toUpperCase();
    }
  }

  generarCadenaFiltro(filtros: FiltroPrimeNG): string {
    const expresiones: string[] = [];
    const LIMITE_CARACTERES = 50;

    const obtenerTitle = (field: string): string => {
      const meta = this.metadataTable.find(m => m.field === field);
      return meta ? meta.title : field;
    };

    const truncarTexto = (texto: string): string => {
      if (texto.length > LIMITE_CARACTERES) {
        return texto.substring(0, LIMITE_CARACTERES) + '...';
      }
      return texto;
    };

    // 1. Añadir el Filtro Global 
    // const filtroGlobalRaw = filtros['global'] as FilterMetadata;
    // if (filtroGlobalRaw && filtroGlobalRaw.value !== null && filtroGlobalRaw.value !== '') {
    //   const globalMode = (filtroGlobalRaw.matchMode || 'CONTAINS').toUpperCase();
    //   expresiones.push(`(FILTRO GLOBAL: ${globalMode} '${filtroGlobalRaw.value}')`);
    // }

    // 2. Procesar Filtros por Columna
    for (const columna in filtros) {
      if (columna !== 'global') {
        const condiciones = filtros[columna] as FilterMetadata[];

        if (Array.isArray(condiciones)) {

          const titleColumna = obtenerTitle(columna);
          const filtrosColumnaActivos = condiciones
            // Filtramos solo las condiciones que tienen un valor asignado
            .filter(condicion => condicion.value !== null && condicion.value !== '')
            .map(filtro => {
              const operador = this.getOperadorExpresion(filtro.matchMode, columna);
              let valorRepresentacion = filtro.value;

              if (valorRepresentacion instanceof Date) {
                const fechaFormateada = this.util.formatearfecha(valorRepresentacion, 'yyyy-mm-dd');
                valorRepresentacion = `'${fechaFormateada}'`;
              }
              else if (typeof valorRepresentacion === 'string') {
                valorRepresentacion = `'${valorRepresentacion}'`;
              } else if (Array.isArray(valorRepresentacion)) {
                // Manejar filtros de selección múltiple (multiselect) de PrimeNG
                valorRepresentacion = `(${valorRepresentacion.map(v => `'${v}'`).join(' O ')})`;
                // Para el multiselect, el operador es implícitamente "IN" (IGUAL A uno de)
                // return `<b>[${titleColumna}]</b> ES IGUAL A UNO DE ${valorRepresentacion}`;
                const valoresTruncados = truncarTexto(valorRepresentacion);
                return `<b>[${titleColumna}]</b> ES IGUAL A UNO DE ${valoresTruncados}`;
              }

              // Formato final: [Columna] OPERADOR Valor
              // return `<b>[${titleColumna}]</b> ${operador} ${valorRepresentacion}`;
              const valorFinal = truncarTexto(String(valorRepresentacion));
              return `<b>[${titleColumna}]</b> ${operador} ${valorFinal}`;
            });

          if (filtrosColumnaActivos.length > 0) {
            // Unimos las múltiples condiciones de una columna con su operador interno (usamos el 'operator' del JSON)
            const operadorInterno = (condiciones[0].operator || 'and').toUpperCase();
            expresiones.push(`(${filtrosColumnaActivos.join(` ${operadorInterno} `)})`);
          }
        }
      }
    }

    // 3. Concatenar todas las expresiones con " Y " (AND)
    if (expresiones.length > 0) {
      return expresiones.join(" Y ");
    } else {
      return "";
    }
  }

  notificarCambioFiltros(): void {
    const filtrosActuales = this.table.filters;
    this.cadenaFiltrosConsolidada.set(this.generarCadenaFiltro(filtrosActuales));

    // console.log("--- 🔎 Cadena de Filtro Consolidada Actualizada 📝 ---");
    // console.log(this.cadenaFiltrosConsolidada());
    // console.log(this.table)
    // console.log("-------------------------------------------------------");
  }

  onTableFilter(event: any): void {
    const filters = event.filters;
    let customFilterApplied = false;

    for (const field in filters) {
      if (filters.hasOwnProperty(field)) {
        const filterData = filters[field];
        const meta = this.metadataTable.find(m => m.field === field);

        // if (meta && meta.type === 'autocomplete') {
        //   const condition = Array.isArray(filterData) ? filterData[0] : filterData;

        //   if (condition && condition.value !== null && condition.value.trim() !== '') {
        //     customFilterApplied = true;
        //   }
        // }
      }
    }

    this.notificarCambioFiltros();
  }

  limpiarFoco() {
    this.cdr.detectChanges();
  }


}

interface FiltroPrimeNG {
  [key: string]: FilterMetadata | FilterMetadata[];
  global?: { value: any, matchMode: string };
}
